import { combineReducers } from 'redux';

import commonReducers from 'reducers/commonReducers';

const reducers = (extraReducers = {}) => combineReducers({ ...commonReducers, ...extraReducers });

export default reducers;
